import isNull from 'lodash/isNull'

export default class Accordion {

    constructor() {
        this.cacheDom()
        this.bindEvents()
    }

    cacheDom() {
        this.accordionBtn = document.querySelectorAll('.accordion__button')
        this.accordions = document.querySelectorAll('.accordion')
    }

    bindEvents() {
        if (!isNull(this.accordionBtn)) {
            Array.prototype.forEach.call(this.accordionBtn, (el, i) => {
                el.addEventListener('click', () => {
                    const panel = el.nextElementSibling
                    const accordion = el.parentNode

                    if (panel.style.maxHeight) {
                        panel.style.maxHeight = null
                        accordion.classList.remove('active')
                    } else {
                        this.closePanels()
                        panel.style.maxHeight = panel.scrollHeight + 'px'
                        accordion.classList.add('active')
                    }
                })

                this.open(el, i)
            })
        }
    }

    closePanels() {
        if (!isNull(this.accordions)) {
            Array.prototype.forEach.call(this.accordions, (el, i) => {
               if (el.classList.contains('active')) {
                    const panel = el.querySelector('.accordion__panel')
                    if (!isNull(panel)) {
                        el.classList.remove('active')
                        panel.style.maxHeight = null
                    }
               }
            })
        }
    }

    open(element, index = 0) {
        if (index === 0) {
            element.click()
        }
    }
}